import React, { useState } from 'react';
import { Checkbox, Form, Header, Input, Segment, Tab } from 'semantic-ui-react';

function SessionConfigFields({ sessionConfig, handleInputChange, propertyPath }) {
    const handleConfigChange = (e, { name, value }) => {
        handleInputChange(e, { name: `${propertyPath}.${name}`, value });
    };

    return (
        <Segment>
            <Header as="h4">Sessions</Header>
            <Form.Field>
                <label>Min Players:</label>
                <Input
                    type="number"
                    name="minPlayers"
                    title="Min number of players required to start allocating a server"
                    value={sessionConfig.minPlayers}
                    onChange={handleConfigChange}
                />
            </Form.Field>
            <Form.Field>
                <label>Max Players:</label>
                <Input
                    type="number"
                    name="maxPlayers"
                    title="Max number of players allowed in a session"
                    value={sessionConfig.maxPlayers}
                    onChange={handleConfigChange}
                />
            </Form.Field>
            <Form.Field>
                <label>Session Fillup TimeOut:</label>
                <Input
                    type="number"
                    name="fillupTimeOut"
                    title="Max amount of time a session is allowed to wait during fillup for there being enough players"
                    value={sessionConfig.fillupTimeOut}
                    onChange={handleConfigChange}
                />
            </Form.Field>
            <Form.Field>
                <label>Session Allocation TimeOut:</label>
                <Input
                    type="number"
                    name="allocationTimeOut"
                    title="Max amount of time a session is allowed to wait during allocating for finding a server"
                    value={sessionConfig.allocationTimeOut}
                    onChange={handleConfigChange}
                />
            </Form.Field>
            <Form.Field>
                <label>Session Playing ClearOut:</label>
                <Input
                    title="The amount of time after which a playing session will be removed from the dashboard"
                    type="number"
                    name="playingClearOut"
                    value={sessionConfig.playingClearOut}
                    onChange={handleConfigChange}
                />
            </Form.Field>
            <Form.Field>
                <label>Session Expired ClearOut:</label>
                <Input
                    title="The amount of time after which an expired session will be removed from the dashboard"
                    type="number"
                    name="expiredClearOut"
                    value={sessionConfig.expiredClearOut}
                    onChange={handleConfigChange}
                />
            </Form.Field>
        </Segment>
    );
}

function ServerConfigFields({ serverConfig, handleInputChange, propertyPath }) {
    const handleConfigChange = (e, { name, value }) => {
        handleInputChange(e, { name: `${propertyPath}.${name}`, value });
    };

    return (
        <Segment>
            <Header as="h4">Server</Header>
            <Form.Field>
                <label>Server Ready TimeOut:</label>
                <Input
                    title="Timeout after a server is ready and waiting"
                    type="number"
                    name="readyTimeOut"
                    value={serverConfig.readyTimeOut}
                    onChange={handleConfigChange}
                />
            </Form.Field>
            <Form.Field>
                <label>Server Allocated TimeOut:</label>
                <Input
                    title="Timeout after a server is allocated"
                    type="number"
                    name="allocatedTimeOut"
                    value={serverConfig.allocatedTimeOut}
                    onChange={handleConfigChange}
                />
            </Form.Field>
            <Form.Field>
                <label>Player Threshold:</label>
                <Input
                    title="Required player threshold to start a game"
                    type="number"
                    name="playerThreshold"
                    value={serverConfig.playerThreshold}
                    onChange={handleConfigChange}
                />
            </Form.Field>
            <Form.Field>
                <label>Server Playing ClearOut:</label>
                <Input
                    title="The amount of time after which a playing server will be removed from the dashboard"
                    type="number"
                    name="playingClearOut"
                    value={serverConfig.playingClearOut}
                    onChange={handleConfigChange}
                />
            </Form.Field>
            <Form.Field>
                <label>Server Expired ClearOut:</label>
                <Input
                    title="The amount of time after which an expired server will be removed from the dashboard"
                    type="number"
                    name="expiredClearOut"
                    value={serverConfig.expiredClearOut}
                    onChange={handleConfigChange}
                />
            </Form.Field>
            <Form.Field>
                <label>Minimum Remaining Game Time Needed</label>
                <Input
                    title="The amount of minimum game time needed before player can enter"
                    type="number"
                    name="minRemainingGameTimeNeeded"
                    value={serverConfig.minRemainingGameTimeNeeded}
                    onChange={handleConfigChange}
                />
            </Form.Field>
            <Form.Field>
                <label>Score Threshold</label>
                <Input
                    title="The score threshold after which player can not join on going game"
                    type="number"
                    name="scoreThreshold"
                    value={serverConfig.scoreThreshold}
                    onChange={handleConfigChange}
                />
            </Form.Field>
            <Form.Field>
                <label>Wait Time:</label>
                <Input
                    title="The amount of time a server will wait before starting game"
                    type="number"
                    name="waitTime"
                    value={serverConfig.waitTime}
                    onChange={handleConfigChange}
                />
            </Form.Field>
        </Segment>
    );
}

function MmrConfigFields({ mmrConfig, handleInputChange, propertyPath }) {
    const handleConfigChange = (e, { name, value, type, checked }) => {
        const finalValue = type === 'checkbox' ? checked : value;
        handleInputChange(e, { name: `${propertyPath}.${name}`, value: finalValue });
    };

    return (
        <Segment>
            <Header as="h4">MMR</Header>
            <Form.Field>
                <Checkbox
                    toggle
                    title="isMmrEnabled"
                    name="isMmrEnabled"
                    label="MMR Enable/Disable"
                    checked={mmrConfig.isMmrEnabled}
                    onChange={handleConfigChange}
                />
            </Form.Field>
            <Form.Field>
                <label>Phase 1 Waiting time (one level lower and one level upper):</label>
                <Input
                    type="number"
                    name="phase1WaitTime"
                    value={mmrConfig.phase1WaitTime}
                    onChange={handleConfigChange}
                />
            </Form.Field>
            {/*<Form.Field>
                <label>Phase 2 Waiting time: (One Lower Tier)</label>
                <Input
                    type="number"
                    name="phase2WaitTime"
                    value={mmrConfig.phase2WaitTime}
                    onChange={handleConfigChange}
                />
            </Form.Field>
            <Form.Field>
                <label>Phase 3 Waiting time: (One Upper Tier)</label>
                <Input
                    type="number"
                    name="phase3WaitTime"
                    value={mmrConfig.phase3WaitTime}
                    onChange={handleConfigChange}
                />
            </Form.Field>*/}
        </Segment>
    );
}

function FullConfigSegment({ config, handleInputChange, propertyPath }) {
    return (
        <Tab.Pane>
            <SessionConfigFields
                sessionConfig={config.sessionCfg}
                handleInputChange={handleInputChange}
                propertyPath={`${propertyPath}.sessionCfg`}
            />
            <ServerConfigFields
                serverConfig={config.serverCfg}
                handleInputChange={handleInputChange}
                propertyPath={`${propertyPath}.serverCfg`}
            />
            <MmrConfigFields
                mmrConfig={config.mmrConfig}
                handleInputChange={handleInputChange}
                propertyPath={`${propertyPath}.mmrConfig`}
            />
        </Tab.Pane>
    );
}
function TutorialBRConfigWidget({ brConfig, handleInputChange, activeIndex, handleTutorialBRTabChange, propertyPath }) {
    const modeConfigPanes = [
        {
            menuItem: 'Solo',
            render: () => (
                <FullConfigSegment
                    config={brConfig.solo.unrankedCfg}
                    handleInputChange={handleInputChange}
                    propertyPath={`${propertyPath}.solo.unrankedCfg`}
                />
            ),
        },
        {
            menuItem: 'Duo',
            render: () => (
                <FullConfigSegment
                    config={brConfig.duo.unrankedCfg}
                    handleInputChange={handleInputChange}
                    propertyPath={`${propertyPath}.duo.unrankedCfg`}
                />
            ),
        },
        {
            menuItem: 'Quad',
            render: () => (
                <FullConfigSegment
                    config={brConfig.quad.unrankedCfg}
                    handleInputChange={handleInputChange}
                    propertyPath={`${propertyPath}.quad.unrankedCfg`}
                />
            ),
        },
    ];

    return (
        <Tab
            panes={modeConfigPanes}
            menu={{ vertical: false, tabular: true, pointing: true }}
            activeIndex={activeIndex}
            onTabChange={handleTutorialBRTabChange}
        />
    );
}

function RespawnBRConfigWidget({ brConfig, handleInputChange, activeIndex, handleRespawnBRTabChange, propertyPath }) {
    const modeConfigPanes = [
        {
            menuItem: 'Solo',
            render: () => (
                <FullConfigSegment
                    config={brConfig.solo.unrankedCfg}
                    handleInputChange={handleInputChange}
                    propertyPath={`${propertyPath}.solo.unrankedCfg`}
                />
            ),
        },
        {
            menuItem: 'Duo',
            render: () => (
                <FullConfigSegment
                    config={brConfig.duo.unrankedCfg}
                    handleInputChange={handleInputChange}
                    propertyPath={`${propertyPath}.duo.unrankedCfg`}
                />
            ),
        },
        {
            menuItem: 'Quad',
            render: () => (
                <FullConfigSegment
                    config={brConfig.quad.unrankedCfg}
                    handleInputChange={handleInputChange}
                    propertyPath={`${propertyPath}.quad.unrankedCfg`}
                />
            ),
        },
    ];

    return (
        <Tab
            panes={modeConfigPanes}
            menu={{ vertical: false, tabular: true, pointing: true }}
            activeIndex={activeIndex}
            onTabChange={handleRespawnBRTabChange}
        />
    );
}

function BRConfigWidget({ brConfig, handleInputChange, activeIndex, handleBRTabChange, propertyPath }) {
    // Separate state for ranked/unranked tabs for each mode
    const [soloRankTab, setSoloRankTab] = useState(0);
    const [duoRankTab, setDuoRankTab] = useState(0);
    const [quadRankTab, setQuadRankTab] = useState(0);

    const handleSoloRankTabChange = (e, { activeIndex }) => {
        setSoloRankTab(activeIndex);
    };

    const handleDuoRankTabChange = (e, { activeIndex }) => {
        setDuoRankTab(activeIndex);
    };

    const handleQuadRankTabChange = (e, { activeIndex }) => {
        setQuadRankTab(activeIndex);
    };

    const modeConfigPanes = [
        {
            menuItem: 'Solo',
            render: () => (
                <Tab
                    panes={[
                        {
                            menuItem: 'Ranked',
                            render: () => (
                                <FullConfigSegment
                                    config={brConfig.solo.rankedCfg}
                                    handleInputChange={handleInputChange}
                                    propertyPath={`${propertyPath}.solo.rankedCfg`}
                                />
                            ),
                        },
                        {
                            menuItem: 'Unranked',
                            render: () => (
                                <FullConfigSegment
                                    config={brConfig.solo.unrankedCfg}
                                    handleInputChange={handleInputChange}
                                    propertyPath={`${propertyPath}.solo.unrankedCfg`}
                                />
                            ),
                        },
                    ]}
                    activeIndex={soloRankTab}
                    onTabChange={handleSoloRankTabChange}
                />
            ),
        },
        {
            menuItem: 'Duo',
            render: () => (
                <Tab
                    panes={[
                        {
                            menuItem: 'Ranked',
                            render: () => (
                                <FullConfigSegment
                                    config={brConfig.duo.rankedCfg}
                                    handleInputChange={handleInputChange}
                                    propertyPath={`${propertyPath}.duo.rankedCfg`}
                                />
                            ),
                        },
                        {
                            menuItem: 'Unranked',
                            render: () => (
                                <FullConfigSegment
                                    config={brConfig.duo.unrankedCfg}
                                    handleInputChange={handleInputChange}
                                    propertyPath={`${propertyPath}.duo.unrankedCfg`}
                                />
                            ),
                        },
                    ]}
                    activeIndex={duoRankTab}
                    onTabChange={handleDuoRankTabChange}
                />
            ),
        },
        {
            menuItem: 'Quad',
            render: () => (
                <Tab
                    panes={[
                        {
                            menuItem: 'Ranked',
                            render: () => (
                                <FullConfigSegment
                                    config={brConfig.quad.rankedCfg}
                                    handleInputChange={handleInputChange}
                                    propertyPath={`${propertyPath}.quad.rankedCfg`}
                                />
                            ),
                        },
                        {
                            menuItem: 'Unranked',
                            render: () => (
                                <FullConfigSegment
                                    config={brConfig.quad.unrankedCfg}
                                    handleInputChange={handleInputChange}
                                    propertyPath={`${propertyPath}.quad.unrankedCfg`}
                                />
                            ),
                        },
                    ]}
                    activeIndex={quadRankTab}
                    onTabChange={handleQuadRankTabChange}
                />
            ),
        },
    ];

    return (
        <Tab
            panes={modeConfigPanes}
            menu={{ vertical: false, tabular: true, pointing: true }}
            activeIndex={activeIndex}
            onTabChange={handleBRTabChange}
        />
    );
}

const ModeConfigWidget = ({ adminCfg, handleInputChange, activeTab, handleTabChange }) => {
    const [activeBR, setActiveFullBR] = useState(0);
    const [activeTutorialBR, setActiveTutorialBR] = useState(0);
    const [activeFppBR, setActiveFppBR] = useState(0);
    const [activeRespawnBR, setActiveRespawnBR] = useState(0);
    const [activeBRX, setActiveBRX] = useState(0);

    const handleFullBRChange = (e, { activeIndex }) => {
        setActiveFullBR(activeIndex);
    };

    const handleTutorialBRChange = (e, { activeIndex }) => {
        setActiveTutorialBR(activeIndex);
    };

    const handleRespawnBRChange = (e, { activeIndex }) => {
        setActiveRespawnBR(activeIndex);
    };
    const handleFppBRChange = (e, { activeIndex }) => {
        setActiveFppBR(activeIndex);
    };

    const handleBRXChange = (e, { activeIndex }) => {
        setActiveBRX(activeIndex);
    }
    const modeConfigPanes = [
        {
            menuItem: 'MiniBR',
            render: () => (
                <FullConfigSegment
                    config={adminCfg.modeCfg.miniBR.solo.unrankedCfg}
                    handleInputChange={handleInputChange}
                    propertyPath="miniBR.solo.unrankedCfg"
                />
            ),
        },
        {
            menuItem: 'FullBR',
            render: () => (
                <BRConfigWidget
                    brConfig={adminCfg.modeCfg.fullBR}
                    handleInputChange={handleInputChange}
                    activeIndex={activeBR}
                    handleBRTabChange={handleFullBRChange}
                    propertyPath="fullBR"
                />
            ),
        },
        {
            menuItem: 'FppBR',
            render: () => (
                <BRConfigWidget
                    brConfig={adminCfg.modeCfg.fppBR}
                    handleInputChange={handleInputChange}
                    activeIndex={activeFppBR}
                    handleBRTabChange={handleFppBRChange}
                    propertyPath="fppBR"
                />
            ),
        },
        {
            menuItem: 'TutorialBR',
            render: () => (
                <TutorialBRConfigWidget
                    brConfig={adminCfg.modeCfg.tutorialBR}
                    handleInputChange={handleInputChange}
                    activeIndex={activeTutorialBR}
                    handleTutorialBRTabChange={handleTutorialBRChange}
                    propertyPath="tutorialBR"
                />
            ),
        },
        {
            menuItem: 'RespawnBR',
            render: () => (
                <RespawnBRConfigWidget
                    brConfig={adminCfg.modeCfg.respawnBR}
                    handleInputChange={handleInputChange}
                    activeIndex={activeRespawnBR}
                    handleRespawnBRTabChange={handleRespawnBRChange}
                    propertyPath="respawnBR"
                />
            ),
        },
        {
            menuItem: 'BRX',
            render: () => (
                <BRConfigWidget
                    brConfig={adminCfg.modeCfg.brx}
                    handleInputChange={handleInputChange}
                    activeIndex={activeBRX}
                    handleBRTabChange={handleBRXChange}
                    propertyPath="brx"
                />
            ),
        },
    ];

    return (
        <Tab
            panes={modeConfigPanes}
            menu={{ vertical: false, tabular: false, pointing: true }}
            activeIndex={activeTab}
            onTabChange={handleTabChange}
        />
    );
};

export default ModeConfigWidget;